import React from 'react';
import { t, tscope, jsx } from '@i18n';
import { Statement } from '@assets/images';
import { Card, Divider } from 'ui';
import {
  DOCUMENT_TYPES,
  DocumentSection,
  UploadFormContainer,
} from '../components';
import { useController } from './hooks';

const ts = tscope(
  'Documents.bankStatementContent',
  {
    t: jsx,
    months: <b>{t('Common.months', { count: 2 })}</b>,
  },
);

const type = DOCUMENT_TYPES.BANK_STATEMENT;

export const UploadBankStatement = () => {
  const {
    control,
    isLoading,
    clearField,
    onePeriodAgo,
    otherDocument,
    onUploadError,
    areDocumentsReady,
    onUploadCompleted,
    onRemoveCompleted,
    lastPeriodDocument,
  } = useController();

  return (
    <UploadFormContainer
      t={ts}
      imageElement={<Statement width="100%" height="100%" data-testid="image" />}
      type={type}
      areDocumentsReady={areDocumentsReady}
    >
      <Card marginBottom="5">
        <DocumentSection
          t={ts}
          name="lastPeriod"
          filesCount={100}
          control={control}
          isDisabled={isLoading}
          clearField={clearField}
          document={lastPeriodDocument}
          onUploadError={onUploadError}
          onRemoveCompleted={onRemoveCompleted}
          onUploadCompleted={onUploadCompleted}
        />
        <Divider />
        <DocumentSection
          t={ts}
          name="onePeriodAgo"
          filesCount={100}
          control={control}
          isDisabled={isLoading}
          document={onePeriodAgo}
          clearField={clearField}
          onUploadError={onUploadError}
          onRemoveCompleted={onRemoveCompleted}
          onUploadCompleted={onUploadCompleted}
        />
      </Card>
      <Card>
        <DocumentSection
          t={ts}
          name="other"
          filesCount={100}
          control={control}
          isDisabled={isLoading}
          clearField={clearField}
          document={otherDocument}
          onUploadError={onUploadError}
          onRemoveCompleted={onRemoveCompleted}
          onUploadCompleted={onUploadCompleted}
        />
      </Card>
    </UploadFormContainer>
  );
};
